module.exports = __webpack_public_path__ + "img/2.ac970d11.png";